export default __webpack_public_path__ + "static/media/london.183e6947.jpg";